module.exports = __webpack_public_path__ + "./docs/img/big-icon-object.ee7f47b8543e05b375970537fc3c8528.svg";